import { toast, ToastOptions, TypeOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

export function useTostify() {
	const defaultOptions: ToastOptions = {
		position: 'top-center',
		autoClose: 5000,
		hideProgressBar: true,
		closeOnClick: true,
		pauseOnHover: false,
		draggable: false,
		progress: undefined,
		theme: 'colored',
		pauseOnFocusLoss: true
	};

	return (message: string, type: TypeOptions = 'error') => {
		return toast(message, { ...defaultOptions, type: type });
	};
}
